//
// Module for the GL Transactions report criteria
//
rs.module("content/reports/criteria/gltransactionscriteria",

    ["common/visibility", "common/select-helper" ],

    function (visibility, selectHelper) {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, glTransactionsReportTypeOption, openCodeValueKey, currentDate) {
            var criteria = $.js(jsSelectors.criteria);
            var reportTypeSelect = criteria.js(jsSelectors.reportTypeSelect);
            var glTransactionStatusSelect = criteria.js(jsSelectors.glTransactionStatusSelect);
            var glSourceSelect = criteria.js(jsSelectors.glSourceSelect);
            var glTransactionTypeSelect = criteria.js(jsSelectors.glTransactionTypeSelect);
            var fromDateInput = criteria.js(jsSelectors.fromDateInput);
            var toDateInput = criteria.js(jsSelectors.toDateInput);
            var includeExportedCheckBox = criteria.js(jsSelectors.includeExportedCheckBox);
            var glTransactionsSection = criteria.js(jsSelectors.glTransactionsSection);
            var glExportedDataSection = criteria.js(jsSelectors.glExportedDataSection);

            // Get Select Helper for Select Lists where we're updating their options and properties
            var glTransactionTypeSelectHelper = selectHelper.getHelper(glTransactionTypeSelect);

            // Register reportTypeSelect change event to hide/show appropriate fields
            reportTypeSelect.change(reportTypeChanged);

            // Register glTransactionStatusSelect change event to hide/show appropriate fields
            glTransactionStatusSelect.change(glTransactionStatusChanged);

            // Register glSourceSelect change event to hide/show appropriate fields
            glSourceSelect.change(glSourceChanged);

            // Setup dependent fields based on reportTypeSelect changed
            function reportTypeChanged() {
                visibility.setVisible(glTransactionsSection, reportTypeSelect.val() == glTransactionsReportTypeOption);
                visibility.setVisible(glExportedDataSection, reportTypeSelect.val() != glTransactionsReportTypeOption);
            }

            // Setup dependent fields based on glTransactionStatusSelect changed
            function glTransactionStatusChanged() {
                if (glTransactionStatusSelect.val() == openCodeValueKey) {
                    fromDateInput.clearErrors().val('');
                    toDateInput.clearErrors().val('');
                    includeExportedCheckBox.setChecked(false);
                    includeExportedCheckBox.prop('disabled', true);
                }
                else {
                    fromDateInput.clearErrors().val(new Date(currentDate).toISODateString());
                    toDateInput.clearErrors().val(new Date(currentDate).toISODateString());
                    includeExportedCheckBox.prop('disabled', false);             
                }
            }

            // Setup dependent fields based on glSourceSelect changed
            function glSourceChanged() {
                var sourceSelected = glSourceSelect.val() !== '';

                if (sourceSelected) {
                    glTransactionTypeSelectHelper.setValue('').setDisabled(true);
                }
                else {
                    glTransactionTypeSelectHelper.setDisabled(false);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);